// extracted by mini-css-extract-plugin
module.exports = {"container":"FramesView_container__3oQ9c","overlay":"FramesView_overlay__iAxTg"};